// const SETPROGRESS = 'SETPROGRESS';
const SETETAPES = 'SETETAPES';
const SETETAPEBAR = 'SETETAPEBAR';
const SETURLENSAVOIRPLUS = 'SETURLENSAVOIRPLUS';


const getters = {

  getEtapes: state => state.etapes,
  getEtapeBar: state => state.etapeBar,
  getUrlEnSavoirPlus: state => state.urlEnSavoirPlus,
};

const actions = {
  setEtapes({ commit }, etapes) {
    commit(SETETAPES, etapes);
  },
  setEtapeBar({ commit }, etapeBar) {
    commit(SETETAPEBAR, etapeBar);
  },
  setUrlEnSavoirPlus({ commit }, url) {
    commit(SETURLENSAVOIRPLUS, url);
  },
};

// mutations
/* eslint-disable no-param-reassign */
const mutations = {
  [SETETAPES](state, etapes) {
    state.etapes = etapes;
  },
  [SETETAPEBAR](state, etapeBar) {
    state.etapeBar = etapeBar;
  },
  [SETURLENSAVOIRPLUS](state, url) {
    state.urlEnSavoirPlus = url;
  },
};

const state = {
  etapes: [
    { id: 1, nom: 'Saisie des données', active: 'active' },
    { id: 2, nom: 'Impression de la déclaration de prélèvement', active: '' },
  ],
  etapeBar: {
    currentStep: 1,
    lastStep: 2,
    valueNow: 50,
    valueMin: 0,
    valueMax: 100,
    width: 'width:50%;',
    titre: 'Formulaire Prélévement',
  },
  urlEnSavoirPlus: 'https://www.ge.ch/impot-source/baremes-perception-b-c-h-calculette-impot-source',
};


export default {
  state,
  mutations,
  getters,
  actions,
};
